import { type LeadConversionMetrics } from "../../lib/lead-types.ts";

interface Props {
  metrics: LeadConversionMetrics;
}

export function LeadConversionFunnel({ metrics }: Props) {
  return (
    <div className="lead-funnel-card">
      <div className="lead-funnel-header">
        <div className="lead-funnel-title">
          <span className="lead-funnel-badge">Sales &amp; Outreach Funnel</span>
          <h3>App Conversion Pipeline</h3>
        </div>
        <div className="lead-funnel-rate-highlight">
          <span className="lead-rate-label">App Conversion Rate</span>
          <span className="lead-rate-value">
            {metrics.conversionRate}%
            <span className="lead-rate-sub">
              ({metrics.convertedCount} of {metrics.totalLeads} leads)
            </span>
          </span>
        </div>
      </div>

      <div className="lead-funnel-grid">
        <div className="lead-funnel-step">
          <div className="lead-step-num">{metrics.totalLeads}</div>
          <div className="lead-step-label">Total Leads</div>
          <div className="lead-step-sub">Identified prospects</div>
          <div className="lead-step-bar" style={{ width: "100%" }} />
        </div>

        <div className="lead-funnel-arrow" aria-hidden="true">→</div>

        <div className="lead-funnel-step">
          <div className="lead-step-num">{metrics.contactedCount}</div>
          <div className="lead-step-label">Contacted</div>
          <div className="lead-step-sub">{metrics.contactedRate}% of total</div>
          <div
            className="lead-step-bar lead-bar-contacted"
            style={{ width: `${Math.min(100, Math.max(10, metrics.contactedRate))}%` }}
          />
        </div>

        <div className="lead-funnel-arrow" aria-hidden="true">→</div>

        <div className="lead-funnel-step">
          <div className="lead-step-num">{metrics.repliedCount}</div>
          <div className="lead-step-label">Replied / Engaged</div>
          <div className="lead-step-sub">{metrics.responseRate}% response</div>
          <div
            className="lead-step-bar lead-bar-replied"
            style={{ width: `${Math.min(100, Math.max(10, metrics.responseRate))}%` }}
          />
        </div>

        <div className="lead-funnel-arrow" aria-hidden="true">→</div>

        <div className="lead-funnel-step lead-step-converted">
          <div className="lead-step-num">{metrics.convertedCount}</div>
          <div className="lead-step-label">Converted Users</div>
          <div className="lead-step-sub">{metrics.conversionRate}% app conversion</div>
          <div
            className="lead-step-bar lead-bar-converted"
            style={{ width: `${Math.min(100, Math.max(10, metrics.conversionRate))}%` }}
          />
        </div>
      </div>
    </div>
  );
}
